<template>
    <section class="parution-extrait">
        <GoBack />
        {{ article.product.extrait.title }}
    </section>
</template>
<script>
import articlesJSON from '@/content.js';
import GoBack from '@/components/GoBack'
export default {
    //name: "article",
    components: {
        GoBack
    },
    data() {
        return {
            
        }
    },
    props: {
        slug: {
            type: String,
            required: true
        }
    },
    computed: {
        article(){
            return articlesJSON.articles.find(
                article => article.slug === this.slug
            )
        }
    },
    methods: {
        isLongTitle($title){
            if($title.length > 7){
                return true
            }
        },
        hexToRgbA(hex, alpha){
            var r = parseInt(hex.slice(1, 3), 16),
            g = parseInt(hex.slice(3, 5), 16),
            b = parseInt(hex.slice(5, 7), 16);

            if (alpha) {
                return "rgba(" + r + ", " + g + ", " + b + ", " + alpha + ")";
            } else {
                return "rgb(" + r + ", " + g + ", " + b + ")";
            }
        }
    },
    mounted() {
        window.componentInstance.setBackground('offwhite');
    },
    updated(){

    },
    beforeDestroy() {
        
    }
  }
</script>
<style lang="scss" scoped>
  
</style>